export class FATCAQuestionnaire{
    constructor(
        public OfferID?: Number,
        public Q1NP?: Boolean,
        public Q2NP?: Boolean,
        public Q1LE?: Boolean,
        public Q2LE?: Boolean,
        public Q3LE?: Boolean,
        public Q4LE?: Boolean){}
}